<template>
  <Breadcrumbs :breadcrumbs="breadcrumbs" />
  <BaseCustomHTMLContent
    class="container"
    :custom-html-content="data?.websitePage?.content"
  />
</template>

<script setup lang="ts">
import { useRouteParams } from "@vueuse/router";
import { useWebsitePageQuery } from "~/graphql/generated";

const path = useRouteParams<string>("slug");

const { data, error } = await useWebsitePageQuery({
  variables: {
    websitePage: {
      path: `/${path.value}`,
    },
  },
});

if (error?.value || !data.value?.websitePage) {
  throw createError({ statusCode: 404, fatal: true });
}

// Set the breadcrumbs
const breadcrumbs = ref([
  {
    to: data.value?.websitePage?.path ?? "/",
    text: data.value?.websitePage?.title ?? "",
  },
]);

useHead({
  title: data.value?.websitePage?.title,
  meta: [
    {
      name: "description",
      content: data.value?.websitePage?.metaDescription ?? "",
    },
  ],
});
</script>

<style lang="scss" scoped>
.container:deep(img) {
  max-width: 100%;
}
</style>
